import { render, staticRenderFns } from "./ReviewPageRe.vue?vue&type=template&id=26d9ed55&scoped=true"
import script from "./ReviewPageRe.vue?vue&type=script&lang=js"
export * from "./ReviewPageRe.vue?vue&type=script&lang=js"
import style0 from "./ReviewPageRe.vue?vue&type=style&index=0&id=26d9ed55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d9ed55",
  null
  
)

export default component.exports